<template>
  <!-- style="margin:50px" -->
    <div v-resize="windowResized">
      <div @click.stop="dialog = !dialog" class="clickable">
        <!-- @slot Use this slot to open the dialog -->
        <slot name="activator"></slot>
      </div>
      <v-dialog :width="generatedWidth" :height="generatedHeight" style="margin:50px" v-model="dialog" :fullscreen="fullscreen"  scrollable :dark="globalDarkMode" :light="!globalDarkMode">
        <!-- @slot Use this slot to give any description for that card -->
        <slot name="dialog">
          <v-card>

            <v-card-title>{{title}} <v-btn style="opacity:.5" icon absolute right @click="dialog = false"><v-icon>mdi-close-circle</v-icon></v-btn></v-card-title>
            <v-card-text>
              <!-- @slot Default slot shows additional html elements if mentioned -->
              <slot></slot>
            </v-card-text>


            <v-card-actions class="d-flex" tile>
              <!-- @slot Use this slot to perform button events like Ok, cancel, done, close -->
              <slot name="actions">
                <v-toolbar dense flat color="transparent">
                  <v-btn v-if="!!cancel" color="primary" text @click="handleCancel">Cancel</v-btn>
                  <v-spacer />
                  <v-btn v-if="!!ok" color="primary" @click="handleOk">OK</v-btn>
                </v-toolbar>
              </slot>
            </v-card-actions>
          </v-card>
        </slot>
      </v-dialog>
    </div>
</template>

<script>

import userSettings from "@/_mixins/user-settings-mixin"
export default {
  name: "DialogCard",
  components: {},
  mixins : [userSettings],
  props : {
    /**
     * If the value is true the dialog will be opened automatically when the page is refreshed
     */
    value : {type:Boolean,default:false},
    /**
     * Sets width for the dialog card
     */
    width : {type:Number,default:600},
    /**
     * Gives title for the dialog card
     */
    title : {type:String,default:"Untitled"},
    /**
     * Ok function triggers when the values are statisfied with the user
     */
    ok : {type:Function},
    /**
     * Cancel function triggers when the user doesn't want much information
     */
    cancel : {type:Function},
    /**
     * Sets dark theme
     */
    dark : {type:Boolean, default:true},
    /**
     * Sets light theme
     */
    light : {type:Boolean, default:false},
    /**
     * Allows the dialog card to be in fullscreen
     */
    fullscreen : {type:Boolean, default:false},
    /**
     * Used to calculate the height and width of the card
     */
    margin : {type:Number, default:100},
    //Munmun : set this value to 50 only for md, lg and xl.  Anything lower: 0
    //this.$vuetify.breakpoint (xs,...  xl)
    //create a computed that uses the logic and that computed is what you place into the dialog prop
  },
  created() {
    var body = window.document.querySelector("body");
    this.setSizes(body);
  },
  data() {
    return {
      dialog : false,
      generatedWidth : null,
      generatedHeight : null,
    }
  },
  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newValue) {
      /**
       * Update the input if the value changed
       */
      this.$emit("input", newValue);
    },
  },
  computed : {
  },
  methods : {
    windowResized(event)
    {
      if(!!event)
      {
        var body = event.srcElement.document.querySelector("body");
        this.setSizes(body);
      }
    },
    setSizes(body)
    {
      if(this.fullscreen)
      {
        var windowWidth = body.offsetWidth;
        var windowHeight = body.offsetHeight;
        this.generatedWidth = windowWidth - this.margin * 2;
        this.generatedHeight = windowHeight - this.margin * 2;
      }
      else
      {
        this.generatedWidth = this.width;
      }
    },
    handleOk() {
      this.ok();
    },
    handleCancel() {
      this.cancel();
    },
  },
};
</script>

<style scoped lang="scss">
.clickable
{
  cursor: pointer;
}
</style>
